import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import EligibilityVerification from '../../Patients/Patientdetails/EligibilityVerification/EligibilityVerification';
import {makeStyles} from '@material-ui/core';
import {useTranslation} from 'react-i18next';
import {_setActiveTab} from '@shared/store/actions/PatientDrawerAction';
import {PatientsTabKeys} from '@shared/constants/Mapping';

const styles = makeStyles(() => ({
  noAppointmentSelectedWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    flexDirection: 'column',
    gap: '0.5rem'
  },
  selectAnAppointment: {
    paddingTop: 0
  }
}));

function EligibilityVerificationContainer(): React.ReactElement {
  const classes = styles();
  // FIXME: ADD PROPER TYPES
  const patientDetailsDrawer = useSelector(
    (state: any) => state.patientDetailsDrawer
  );
  const groupId = useSelector((state: any) => state.auth.groupId);
  const isAppointmentSelected = !!patientDetailsDrawer?.eligibilityVerificationAppointment;

  const {t} = useTranslation();

  const dispatch = useDispatch();

  const handleSelectAppointment = () => {
    dispatch(_setActiveTab(PatientsTabKeys.APPOINTMENTS));
  };

  return (
    <>
      {!isAppointmentSelected && (
        <div className={classes.noAppointmentSelectedWrapper}>
          {t(`ELIGIBILITY_VERIFICATION.NO_APPOINTMENT_IS_SELECTED`)}
          <p
            className={`link-style ${classes.selectAnAppointment}`}
            onClick={handleSelectAppointment}>
            {t(`ELIGIBILITY_VERIFICATION.SELECT_AN_APPOINTMENT`)}
          </p>
        </div>
      )}
      {isAppointmentSelected && (
        <EligibilityVerification
          patientId={patientDetailsDrawer?.patientId}
          clinicId={
            patientDetailsDrawer?.eligibilityVerificationAppointment?.clinic_id
          }
          groupId={groupId}
          appointment={patientDetailsDrawer?.eligibilityVerificationAppointment}
        />
      )}
    </>
  );
}

export default EligibilityVerificationContainer;
